import React from 'react';
import { useLocation } from 'react-router-dom';
import CustomCard from '../register-form/CustomCard';
import Signup from './Signup';

const commuteForButtons = [
  { text: "Office", link: "/signup?services=start&mode=office" },
  { text: "University", link: "/signup?services=start&mode=university" }
];

const serviceOfferButtons = [
  { text: "Looking for a Car", link: "/signup?step=signup&mode=rider-registration" },
  { text: "Offering Your Car", link: "/signup?step=signup&mode=driver-registration" }
];

const SignupPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const stepSignUp = queryParams.get('step');
  const servicesFor = queryParams.get('services');


  if (stepSignUp) {
    return (
<div
  className="container-fluid"
  style={{
    backgroundColor: "#35677e",
    minHeight: "100vh",
    padding: 0,
    margin: 0,
  }}
>
  <div
    className="mx-auto"
    style={{
      maxWidth: "450px",
      paddingTop: "4vh",
      paddingBottom: "4vh",
    }}
  >
    <Signup />
  </div>
</div>
    );
  }

  return (
    <div style={{ 
        width: '100%' ,
    }}>
      {servicesFor === "start" ? (
        <CustomCard title="Are you" buttons={serviceOfferButtons} footer="On long term basis" />
      ) : (
        <CustomCard title="Do you want to Commute to" buttons={commuteForButtons} footer="On long term basis" />
      )}
    </div>
  );
};

export default SignupPage;